var React = require('react');

function MapMarker (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.1875 25.7819C10.527 26.606 9.27301 26.606 8.61249 25.7819C2.88177 18.6316 0 13.4444 0 9.9C0 4.43238 4.43238 0 9.9 0C15.3676 0 19.8 4.43238 19.8 9.9C19.8 13.4444 16.9182 18.6316 11.1875 25.7819Z","fill":"#001833"}));
}

MapMarker.defaultProps = {"width":"20","height":"27","viewBox":"0 0 20 27","fill":"none"};

module.exports = MapMarker;

MapMarker.default = MapMarker;
